<template>
  <div>
    <template v-if="disabled">
      <uploader class="uploader-example">
        <uploader-list>
          <div class="uploader-list" slot-scope="{ fileList }">
            <ul style="list-style: none; padding-left: 0">
              <li v-for="file in fileList" :key="file.id">
                <uploader-file
                  v-if="value.filter((f) => f.id === 'uploaded_' + file.id).length === 0"
                  :file="file"
                ></uploader-file>
              </li>
            </ul>
            <ul style="list-style: none; padding-left: 0">
              <li v-for="Sfile in value" :key="Sfile.id">
                <uploader-fileSaved @removed="onRemoved" :file="Sfile"></uploader-fileSaved>
              </li>
            </ul>
          </div>
        </uploader-list>
      </uploader>
    </template>
    <template v-if="!disabled">
      <uploader :options="options" class="uploader-example" @file-success="onSuccess" @file-error="onError">
        <uploader-unsupport></uploader-unsupport>

        <uploader-drop v-if="maximumfilecount === null || value.filter((f) => !f.error).length < maximumfilecount">
          <uploader-btn>{{ selectFilesBtn === null ? this.translation(315) : selectFilesBtn }}</uploader-btn
          >&nbsp;
          <span class="upload-drag-drop-text" v-html="this.translation(14975)"></span>
        </uploader-drop>
        <uploader-list>
          <div class="uploader-list" slot-scope="{ fileList }">
            <ul style="list-style: none; padding-left: 0">
              <li v-for="file in fileList" :key="file.id">
                <uploader-file
                  v-if="value.filter((f) => f.id === 'uploaded_' + file.id).length === 0"
                  :file="file"
                ></uploader-file>
              </li>
            </ul>
            <ul style="list-style: none; padding-left: 0">
              <li v-for="Sfile in value" :key="Sfile.id">
                <uploader-fileSaved
                  @removed="onRemoved"
                  :file="Sfile"
                  :showNameAsLink="showNameAsLink"
                  :bijlageicon="bijlageicon"
                ></uploader-fileSaved>
              </li>
            </ul>
          </div>
        </uploader-list>
      </uploader>
    </template>
  </div>
</template>
<script>
import { util } from 'pevueglobal'
import Uploader from '@/components/vue-simple-uploader/components/uploader.vue'
import UploaderBtn from '@/components/vue-simple-uploader/components/btn.vue'
import UploaderDrop from '@/components/vue-simple-uploader/components/drop.vue'
import UploaderUnsupport from '@/components/vue-simple-uploader/components/unsupport.vue'
import UploaderList from '@/components/vue-simple-uploader/components/list.vue'
import UploaderFile from '@/components/vue-simple-uploader/components/file.vue'
import UploaderFileSaved from '@/components/vue-simple-uploader/components/fileSaved.vue'
export default {
  name: 'XVupload',

  components: {
    Uploader,
    UploaderBtn,
    UploaderDrop,
    UploaderUnsupport,
    UploaderList,
    UploaderFile,
    UploaderFileSaved,
  },
  data: function () {
    return {
      options: {
        // target: 'https://localhost:5001/allroles/Upload',
        // target: 'https://xautest09.xaurum.nl:8001/allroles/Upload',
        target: util.createApiUrl('/allroles/Upload'),
        testChunks: false,
        headers: { Authorization: 'bearer ' + util.UgetCookie('kongapikey') },
      },
      attrs: {
        accept: 'image/*',
      },
    }
  },
  props: {
    disabled: { default: false },
    maximumfilecount: { default: null },
    selectFilesBtn: { default: null }, // 'selecteer bestanden'
    acceptedExtensionsMessage: { default: null },
    maxFileSizeMessage: { default: null },
    showNameAsLink: { default: true },
    bijlageicon: { default: false },
    value: {
      default: () => {
        return []
      },
    },
  },
  methods: {
    customValidate(rules) {},
    onRemoved(file) {
      let leftover = this.value.filter((f) => f.uploadFileID !== file.uploadFileID)
      this.$emit('input', leftover)
      this.$forceUpdate()
    },
    onSuccess(rootFile, file, message, chunk) {
      const uploadFileID = JSON.parse(message).uploadFileID
      const fileToken = JSON.parse(message).fileToken
      let savedobj = this.addSavedfile(file.extension, file.name, uploadFileID, rootFile.id, fileToken)
      this.value.push(savedobj)
      file.cancel() // haal uit uploadlijst van de upload control
      this.$emit('input', this.value)
      this.$forceUpdate()
    },
    onError(rootFile, file, message) {
      let error = JSON.parse(message).modelState.file[0]
      file.errormessage = JSON.parse(message).modelState.file[0]
      if (error === 'extension') {
        let errmsg = this.acceptedExtensionsMessage === null ? this.translation(7987) : this.acceptedExtensionsMessage
        this.addErrorfile(file.extension, file.name, errmsg, rootFile.id)
      } else {
        let errmsg = this.maxFileSizeMessage === null ? this.translation(3254) : this.maxFileSizeMessage
        this.addErrorfile(file.extension, file.name, errmsg, rootFile.id)
      }
      file.cancel() // haal uit uploadlijst van de upload control
      this.$emit('input', this.value)
      this.$forceUpdate()
    },
    addErrorfile(extension, name, errormessage, uploadComponentFileID) {
      const foldertemp = {}

      foldertemp.fileType = extension
      foldertemp.name = name
      foldertemp.errormessage = errormessage
      foldertemp.error = true
      foldertemp.id = 'uploaded_' + uploadComponentFileID
      this.value.push(foldertemp)
    },
    addSavedfile(extension, name, uploadFileID, uploadComponentFileID, fileToken) {
      const foldertemp = {}
      // if (!rootFile !== undefined) {
      foldertemp.id = 'uploaded_' + uploadComponentFileID
      // } else {
      //   foldertemp.id = 'Saved_' + uploadComponentFileID
      // }
      foldertemp.justadded = true
      foldertemp.fileType = extension
      foldertemp.extension = extension
      foldertemp.name = name
      foldertemp.uploadFileID = uploadFileID
      foldertemp.fileToken = fileToken
      foldertemp.error = false
      foldertemp.uploadDate = null
      return foldertemp
    },
  },
  async mounted() {
    let uploadids = []

    for (let file of this.value) {
      if (!file.name && file.uploadFileID != null) {
        // toegoevoegd via prop, bestaand document dus, we gaan de naam ophalen
        uploadids.push(file.uploadFileID)
      }
    }
    if (uploadids.length !== 0) {
      let data = await util.getDataApi('allroles/PEapi_GetDocumentNames', { docids: uploadids }, false, false, true)
      let t = 0

      for (let file of data.ds.data0) {
        file.id = 'saved_' + t
        file.error = false
        t++
      }
      this.$emit('input', data.ds.data0)
    }
    // this.$el.value = this.value
  },
}
</script>
<style>
.uploader-list {
  position: relative;
}
.uploader-list > ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
</style>
